import { useState, useEffect } from 'react';

export default function useScrollPosition(scrollingContainer: Element) {
	const [yPosition, setYPosition] = useState(0);

	useEffect(() => {
		if (!scrollingContainer) {
			return;
		}

		function updateScrollValue() {
			if (scrollingContainer) {
				const { scrollTop: refYPosition } = scrollingContainer;
				setYPosition(refYPosition);
			}
		}

		scrollingContainer.addEventListener('scroll', updateScrollValue);

		return () => {
			scrollingContainer.removeEventListener('scroll', updateScrollValue);
		};
	}, [scrollingContainer]);

	return { scrollYPosition: yPosition };
}
